import React, { useState } from 'react'
import Modal from 'react-bootstrap/Modal';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

function UserViewDetails({ formData }) {

    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    return (
        <>
            <OverlayTrigger
                key="tooltip"
                placement="top"
                overlay={<Tooltip id={`tooltip-top`}>View</Tooltip>}
            >
                <button className='border-0' onClick={handleShow}>
                    <img src="../images/png/info-circle.png" alt="" />
                </button>
            </OverlayTrigger>

            <Modal className='modal-main' scrollable show={show} centered size='md' onHide={handleClose}>
                <Modal.Body className='position-relative'>
                    <div className='position-absolute top-0 end-0 me-4 mt-3 cursor-pointer' onClick={handleClose} >
                        <img src="../images/png/close.png" width={12.55} height={12.55} alt="" />
                    </div>
                    <Modal.Title>
                        <div className="row justify-content-center">
                            <div className="col-11 col-8">
                                <h2>Details</h2>
                            </div>
                        </div>
                    </Modal.Title>
                    <div className='modal-form user-view-details-list'>
                        <div className='row mb-3'>
                            <div className="col-12 col-md-6">
                                <p>User Name :</p>
                            </div>
                            <div className="col-12 col-md-7">
                                <span>{formData?.userId?.userName}</span>
                            </div>
                        </div>
                        <div className='row mb-3'>
                            <div className="col-12 col-md-6">
                                <p>Company Name :</p>
                            </div>
                            <div className="col-12 col-md-7">
                                <span>{formData?.companyName}</span>
                            </div>
                        </div>
                        <div className='row mb-3'>
                            <div className="col-12 col-md-6">
                                <p>Company Motto :</p>
                            </div>
                            <div className="col-12 col-md-7">
                                <span>{formData?.companyMotto}</span>
                            </div>
                        </div>

                        <div className='row mb-3'>
                            <div className="col-12 col-md-6">
                                <p>Tag5 :</p>
                            </div>
                            <div className="col-12 col-md-7">
                                <span>{formData?.tag5}</span>
                            </div>
                        </div>
                        <div className='row mb-3'>
                            <div className="col-12 col-md-6">
                                <p>Watermark :</p>
                            </div>
                            <div className="col-12 col-md-7">
                                <span>{formData?.watermark}</span>
                            </div>
                        </div>

                        {formData?.header.length > 0 ? (
                            formData.header.map((head, index) => {
                                return (
                                    <>
                                        <div className='row mb-3'>
                                            <div className="col-12 col-md-6">
                                                <p>Header Left :</p>
                                            </div>
                                            <div className="col-12 col-md-7">
                                                <span>{head.headerLeft}</span>
                                            </div>
                                        </div>
                                        <div className='row mb-3'>
                                            <div className="col-12 col-md-6">
                                                <p>Header Center :</p>
                                            </div>
                                            <div className="col-12 col-md-7">
                                                <span>{head.headerCenter}</span>
                                            </div>
                                        </div>
                                        <div className='row mb-3'>
                                            <div className="col-12 col-md-6">
                                                <p>Header RIght :</p>
                                            </div>
                                            <div className="col-12 col-md-7">
                                                <span>{head.headerRight}</span>
                                            </div>
                                        </div>
                                        <div className='row mb-3'>
                                            <div className="col-12 col-md-6">
                                                <p>Disclaimer :</p>
                                            </div>
                                            <div className="col-12 col-md-7">
                                                <span>{head.disclaimer}</span>
                                            </div>
                                        </div>
                                        <div className='row mb-3'>
                                            <div className="col-12 col-md-6">
                                                <p>Footer left :</p>
                                            </div>
                                            <div className="col-12 col-md-7">
                                                <span>{head.footerLeft}</span>
                                            </div>
                                        </div>
                                        <div className='row mb-3'>
                                            <div className="col-12 col-md-6">
                                                <p>Footer Right :</p>
                                            </div>
                                            <div className="col-12 col-md-7">
                                                <span>{head.footerRight}</span>
                                            </div>
                                        </div>
                                    </>
                                )

                            })
                        ) : (
                            <p>No page added</p>
                        )}

                        <div className='row mb-3'>
                            <div className="col-12 col-md-6">
                                <p>Vendor Suite</p>
                            </div>
                            <div className="col-12 col-md-7">
                                <span>{formData.vendorSuit}</span>
                            </div>
                        </div>
                        <div className='row mb-3'>
                            <div className="col-12 col-md-6">
                                <p>Category :</p>
                            </div>
                            <div className="col-12 col-md-7">
                                <span>{formData?.categoryId?.name}</span>
                            </div>
                        </div>
                        <div className='row mb-3'>
                            <div className="col-12 col-md-6">
                                <p>Template :</p>
                            </div>
                            <div className="col-12 col-md-7">
                                <span>{formData?.templateId?.name}</span>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default UserViewDetails